import { render, staticRenderFns } from "./AnswerEffect.vue?vue&type=template&id=42a55382&scoped=true&"
import script from "./AnswerEffect.vue?vue&type=script&lang=js&"
export * from "./AnswerEffect.vue?vue&type=script&lang=js&"
import style0 from "./AnswerEffect.vue?vue&type=style&index=0&id=42a55382&prod&lang=scss&scoped=true&"
import style1 from "./AnswerEffect.vue?vue&type=style&index=1&id=42a55382&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a55382",
  null
  
)

export default component.exports